import { BaseModel } from "./base-model";

export default class DashboardQuoteListItem {
    id: string;
    no: string;
    identity: string;
    contact: {
        name: string;
        id: string;
    };
    account: {
        name: string;
        id: string;
    };
    type: string;
    orderDate: string;
    total: string;
    salesRep: { name: string };
    status: { name: string };
    paymentStatus: string;
    csr: { id: string; };
    date: { booked: string; invoice: string }
    featuredImage: string;

    constructor(options) {
        this.id = options.id || "";
        this.no = options.no || "";
        this.identity = options.identity || "";
        this.featuredImage = options.featuredImage || "";
        if (options.contact) {
            this.contact = {
                name: options.contact.name || "",
                id: options.contact.id || "",
            };
        } else {
            options.contact = {
                name: "",
                id: ""
            }
        }
        if (options.account) {
            this.account = {
                name: options.account.name,
                id: options.account.id
            }
        } else {
            this.account = {
                name: "",
                id: ""
            }
        }
        this.type = options.type || "";
        this.orderDate = options.orderDate || "";
        this.total = options.subtotal || "";

        this.salesRep = options.salesRep ? {
            name: options.salesRep.name
        } : {
                name: ""
            };
        this.status = options.status ? {
            name: options.status.name
        } : {
                name: ""
            }
        this.paymentStatus = options.paymentStatus || "";
        this.csr = options.csr ? {
            id: options.csr.id
        } : {
                id: ""
            }
        this.date = {
            booked: options.date ? options.date.booked : "",
            invoice: options.date ? options.date.invoice : ""
        }
    }
}